import { Injectable } from '@angular/core';
import { de, enUS, fr } from 'date-fns/locale';
import { loadTranslation } from 'server/shared/helpers/translations/translations';
import { InpoolLanguage } from 'server/shared/models/InpoolLanguage';
import { TranslationKeyTranslation } from 'server/shared/models/translation';
import { User } from 'server/shared/models/user';
import { getLanguage } from 'src/helpers/translationHelpers';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(private userService: UserService) {
    // subscribe user and apply/initialize language
    this.userService.readyUser$.subscribe((user) => {
      if (!user.locale) {
        this.initializeUserLanguage(user);
      } else {
        if (user.locale !== getLanguage()) {
          this.switchLanguage(user.locale);
        }
      }
    });
  }

  /**
   * If the user has no language selected, we take it from the browser language
   */
  initializeUserLanguage(user: User) {
    const currentLanguage = getLanguage();
    this.saveCurrentUserLanguage(currentLanguage).then();
    localStorage.setItem('locale', currentLanguage);
  }

  getDateFnsLocale(): Locale {
    const language = getLanguage();
    switch (language) {
      case 'de':
        return de;
      case 'fr':
        return fr;
      case 'en':
      default:
        return enUS;
    }
  }

  switchLanguage(language: InpoolLanguage) {
    localStorage.setItem('locale', language);
    this.saveCurrentUserLanguage(language).then(() => {
      window.location.reload();
    });
  }

  async saveCurrentUserLanguage(language: InpoolLanguage) {
    return new Promise<void>((resolve, reject) => {
      Meteor.call(
        'updateCurrentUserLanguage',
        language,
        (error: Meteor.Error) => {
          // reload to apply new language
          resolve();
        },
      );
    });
  }

  getLanguage(): InpoolLanguage {
    return getLanguage();
  }

  getTranslations(componentName = ''): TranslationKeyTranslation {
    const locale = getLanguage();
    const translation = loadTranslation(locale);
    return {
      ...translation,
    };
  }
}
